import React, { useMemo } from "react";
import { Col, Row } from "reactstrap";
import { get } from "lodash";
import PropTypes from "prop-types";

import Collapse from "./Collapse";
import { withTranslation } from "react-i18next";

const DeclarationView = ({
  declaration,
  isExpandable = true,
  t,
  isPowerApplication = true,
}) => {
  const fields = useMemo(
    () => [
      {
        name: "Consumer Dues Outstanding",
        key: "consumerDuesOutstanding",
        isRequired: false,
        isVisible: isPowerApplication,
      },
      {
        name: "Firm Dues Outstanding",
        key: "firmDuesOutstanding",
        isRequired: false,
        isVisible: isPowerApplication,
      },
      {
        name: "Premises Dues Outstanding",
        key: "premisesDuesOutstanding",
        isVisible: isPowerApplication,
        isRequired: false,
      },
      {
        name: "Utility dues outstanding in GIFT City area of operation",
        key: "consumerDuesOutstanding",
        renderField: (value) => value || "No",
        isVisible: !isPowerApplication,
        isRequired: false,
      },
      {
        name: "Utility dues outstanding for the premises for which connection applied",
        key: "premisesDuesOutstanding",
        isVisible: !isPowerApplication,
        renderField: (value) => value || "No",
        isRequired: false,
      },
    ],
    [isPowerApplication]
  );

  return (
    <Collapse title="Declaration" isExpandable={isExpandable}>
      <Row className="d-flex  mb-2 ">
        {fields.map(({ isVisible, name, key, isRequired, renderField }) => {
          const value = get(declaration, key, "");
          if (typeof isVisible !== "boolean" || isVisible) {
            return (
              <Col key={key} lg={6} className="mb-1">
                <Row>
                  <Col md={5}>{t(name)}:</Col>
                  <Col md={7} className="fw-semibold">
                    {renderField
                      ? renderField(value)
                      : get(declaration, key, null) ??
                        (isRequired ? "-" : "N/A")}
                  </Col>
                </Row>
              </Col>
            );
          }
        })}
      </Row>
    </Collapse>
  );
};

DeclarationView.propTypes = {
  declaration: PropTypes.object,
  isExpandable: PropTypes.bool,
  isPowerApplication: PropTypes.bool,
  t: PropTypes.func,
};

export default withTranslation()(DeclarationView);
